import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MusicSection = () => {
  const spotifyArtistId = "06NV3L7olz3ocY4pe5GUFZ";
  const [mixes, setMixes] = useState([]);

  useEffect(() => {
    axios.get(`${API}/mixes`)
      .then((res) => setMixes(res.data))
      .catch((err) => console.error("Failed to fetch mixes:", err));
  }, []);

  return (
    <section data-testid="music-section" className="py-24 md:py-32 tracing-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <p className="font-sub text-[10px] text-white/30 tracking-[0.3em] mb-4">001</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tighter">LISTEN</h2>
          <div className="gold-line mt-6" />
        </div>

        {/* Spotify Embed */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="spotify-embed">
              <iframe
                data-testid="spotify-embed"
                title="Spotify Player"
                src={`https://open.spotify.com/embed/artist/${spotifyArtistId}?utm_source=generator&theme=0`}
                width="100%"
                height="352"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                style={{ borderRadius: "12px" }}
              />
            </div>
          </div>

          <div className="space-y-8">
            <p className="font-body text-white/50 text-sm md:text-base leading-relaxed">
              Immerse yourself in the sonic landscape crafted by Alchemist (CA).
              From deep, hypnotic grooves to ethereal melodic journeys — every track
              is an exploration of the space between sound and silence.
            </p>
            <div className="flex flex-col gap-4">
              <a
                data-testid="spotify-profile-link"
                href="https://open.spotify.com/artist/06NV3L7olz3ocY4pe5GUFZ"
                target="_blank"
                rel="noopener noreferrer"
                className="font-sub text-xs text-white/40 hover:text-white tracking-widest transition-colors duration-300 underline-offset-4 hover:underline inline-flex items-center gap-2"
              >
                Full Profile on Spotify
                <span className="text-white/20">&rarr;</span>
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 pt-8 border-t border-white/10">
              <div>
                <p className="font-sub text-[10px] text-white/30 tracking-widest mb-1">BASED IN</p>
                <p className="text-white font-medium">Toronto, CA</p>
              </div>
              <div>
                <p className="font-sub text-[10px] text-white/30 tracking-widest mb-1">GENRE</p>
                <p className="text-white font-medium">Melodic House, Melodic Techno, Deep House, Progressive House</p>
              </div>
            </div>
          </div>
        </div>

        {/* SoundCloud Live Sets */}
        {mixes.length > 0 && (
          <div className="mt-20">
            <p className="font-sub text-[10px] text-white/40 tracking-[0.3em] mb-8">LIVE SETS & MIXES</p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {mixes.map((mix, i) => (
                <div key={mix.id} data-testid={`soundcloud-mix-${i}`} className="space-y-3">
                  <iframe
                    title={mix.title}
                    width="100%"
                    height="166"
                    scrolling="no"
                    frameBorder="no"
                    allow="autoplay"
                    src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(mix.soundcloud_url)}&color=%23333333&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`}
                    style={{ borderRadius: "4px" }}
                  />
                  <p className="font-sub text-[10px] text-white/30 tracking-widest">{mix.title.toUpperCase()}</p>
                </div>
              ))}
            </div>
            <div className="mt-6">
              <a
                data-testid="soundcloud-profile-link"
                href="https://soundcloud.com/gunjan-goel-665914876"
                target="_blank"
                rel="noopener noreferrer"
                className="font-sub text-xs text-white/40 hover:text-white tracking-widest transition-colors duration-300 underline-offset-4 hover:underline inline-flex items-center gap-2"
              >
                All Sets on SoundCloud
                <span className="text-white/20">&rarr;</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
